export var getHrefFaxString = function getHrefFaxString(faxNumber) {
  return "fax:".concat(faxNumber.replace(/\s/g, ''));
};